import classnames from 'classnames'
import ArrowButton from '../ArrowButton/ArrowButton'

import styles from './PreviousArrow.module.scss'

interface PreviousArrowProps {
  className?: string
  onClick?: () => void
  smallerButton?: boolean
}

const PreviousArrow = ({ className, onClick, smallerButton = false }: PreviousArrowProps) => (
  <ArrowButton
    className={classnames(styles.slickPrev, className)}
    isLeftArrow
    onClick={onClick}
    tracking={{ disabled: true, guid: '' }}
    smallerButton={smallerButton}
  />
)

export { PreviousArrow }
